// src/components/Admin/LinkForm.jsx
import React, { useState } from 'react';
import './AdminStyles.css';

const LinkForm = ({ initialData = {}, onSubmit, loading, submitText }) => {
  const [title, setTitle] = useState(initialData.title || '');
  const [url, setUrl] = useState(initialData.url || '');
  const [thumb, setThumb] = useState(initialData.thumb || '');
  const [key, setKey] = useState(initialData.key || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ title, url, thumb, key }); // Passa os dados do formulário para a função onSubmit
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <h2>{submitText === 'Adicionar Link' ? 'Adicionar Novo Link' : 'Editar Link'}</h2>
      <div className="form-group">
        <label htmlFor="title">Título</label>
        <input
          type="text"
          id="title"
          placeholder="Digite o título"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="url">URL</label>
        <input
          type="text"
          id="url"
          placeholder="Digite a URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="thumb">Thumbnail</label>
        <input
          type="text"
          id="thumb"
          placeholder="Digite o link da thumbnail"
          value={thumb}
          onChange={(e) => setThumb(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="key">ID</label>
        <input
          type="text"
          id="key"
          placeholder="Digite o ID"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          required
        />
      </div>
      <div className="form-actions">
        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? 'Salvando...' : submitText}
        </button>
        <button
          type="button"
          className="cancel-button"
          onClick={() => window.history.back()} // Volta para a página anterior
        >
          Voltar
        </button>
      </div>
    </form>
  );
};

export default LinkForm;